export default __webpack_public_path__ + "static/8-WCBL-CHAMPIONSHIPS-2aca4e6043cfbd89ddf53938b9b04fe9.jpg";